import { ApiJsonClientError } from "@/lib/query/core/api-json-client";

export function getQueryErrorStatus(error: unknown) {
  if (error instanceof ApiJsonClientError) {
    return error.status;
  }

  return undefined;
}
